export default "__VITE_ASSET__DoOi781S__"